import { render } from "./viaturaForm.vue?vue&type=template&id=c77127ac&scoped=true"
import script from "./viaturaForm.vue?vue&type=script&lang=js"
export * from "./viaturaForm.vue?vue&type=script&lang=js"

import "./viaturaForm.vue?vue&type=style&index=0&id=c77127ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77127ac"]])

export default __exports__